/**
 * Master Service Agreement Page
 */

export default function MasterServiceAgreementPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Master Service Agreement</h1>
          
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">Last updated: December 15, 2024</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Service Description</h2>
            <p className="text-gray-700 mb-4">
              Pureaum provides supply chain tracking, product authentication, and related technology services to manufacturers and their distribution networks.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Service Levels</h2>
            <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3">Platform Availability</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>99.9% uptime guarantee (excluding scheduled maintenance)</li>
              <li>24/7 monitoring and support</li>
              <li>Disaster recovery and backup systems</li>
            </ul>
            
            <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3">Response Times</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Critical issues: 2 hours</li>
              <li>High priority: 8 hours</li>
              <li>Medium priority: 24 hours</li>
              <li>Low priority: 72 hours</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Client Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              The client agrees to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Provide accurate and complete information</li>
              <li>Maintain data security and access controls</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Pay fees according to the agreed schedule</li>
              <li>Provide reasonable cooperation for service delivery</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Pureaum Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              Pureaum agrees to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Deliver services as specified in the service description</li>
              <li>Maintain platform security and data protection</li>
              <li>Provide technical support during business hours</li>
              <li>Ensure compliance with relevant data protection laws</li>
              <li>Maintain service level agreements</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Pricing and Payment</h2>
            <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3">Service Fees</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Monthly subscription fees as per selected plan</li>
              <li>Transaction-based charges for QR code generation</li>
              <li>Additional fees for premium features</li>
            </ul>
            
            <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3">Payment Terms</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Payment due within 30 days of invoice</li>
              <li>Late payment charges: 2% per month</li>
              <li>Suspension of services for non-payment after 60 days</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Data Ownership and Security</h2>
            <p className="text-gray-700 mb-4">
              Client retains ownership of all data provided to Pureaum. Pureaum implements industry-standard security measures to protect client data.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Intellectual Property</h2>
            <p className="text-gray-700 mb-4">
              Pureaum retains all rights to its platform, technology, and methodologies. Client receives a limited license to use the services.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">
              Pureaum's liability is limited to the fees paid by the client in the 12 months preceding the claim. Pureaum is not liable for indirect, consequential, or punitive damages.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">9. Termination</h2>
            <p className="text-gray-700 mb-4">
              Either party may terminate this agreement with 30 days written notice. Pureaum may terminate immediately for breach of terms or non-payment.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">10. Governing Law</h2>
            <p className="text-gray-700 mb-4">
              This agreement is governed by the laws of India. Disputes will be resolved through arbitration in Mumbai, India.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">11. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              For questions about this Master Service Agreement:
            </p>
            <p className="text-gray-700">
              Email: contracts@pureaum.com<br />
              Phone: +91-XXXX-XXXX-XX<br />
              Address: [Company Address]
            </p>
          </div>
          
          <div className="mt-8 pt-6 border-t">
            <button
              onClick={() => window.close()}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}